export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LkBurgerMenu.vue?vue&type=template&id=064ccaf5&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/header/components/LkBurgerMenu.vue?vue&type=template&id=064ccaf5&
// module id = 1598
// module chunks = 0